import React from 'react';
import { Snackbar } from '@origin-digital/ods-core';

export interface IConfirmAddressSuccessProps {
  open: boolean;
  onClose: () => void;
}

export const ConfirmAddressSuccess: React.FC<IConfirmAddressSuccessProps> = ({ open, onClose }) => {
  return (
    <Snackbar
      data-id="nmi-confirm-address-success-snackbar"
      open={open}
      autoHideDuration={3000}
      tone="positive"
      onClose={onClose}
    >
      Success! We found your address
    </Snackbar>
  );
};
